import axios from 'axios';
import Cache from './cache';

process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = 0;

export default class showernavigatorApi {
    constructor(preview, locale, locales, store, config) {
        this.preview = preview;
        this.locale = locale;
        this.locales = locales;
        this.store = store;
        this.config = config;
        this.allProducts = [];
        this.cache = new Cache(preview === true ? false : parseInt(config.cache, 10) === 1);
    }

    getShowerNavigatorIds() {
        return new Promise((resolve) => {
            const cachedIds = this.cache.getShowerNavigatorProductIds(this.locale);
            if (cachedIds) {
                resolve(cachedIds);
            } else {
                axios
                    .get(`${this.config.pimcoreUrl}/${this.locale}/shower-navigtor`)
                    .then((res) => {
                        if (this.preview) {
                            resolve(res.data);
                        } else {
                            const ids = res.data.map((product) => {
                                this.cache.setShowerNavigatorProduct(product.id, this.locale, product);
                                return product.id;
                            });
                            this.cache.setShowerNavigatorProductIds(this.locale, ids);
                            resolve(ids);
                        }
                    })
                    .catch((e) => {
                        resolve(false);
                        console.error('showernavigator error', e);
                    });
            }
        });
    }

    getShowerNavigatorProduct(id) {
        return new Promise((resolve) => {
            const cachedProduct = this.cache.getShowerNavigatorProduct(id, this.locale);
            if (cachedProduct) {
                resolve(cachedProduct);
            } else {
                resolve(false);
            }
        });
    }

    submitNavigatorSolution(data) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            // email sender
            formData.append('email', data.email);
            formData.append('firstName', data.firstname);
            formData.append('lastName', data.lastname);
            formData.append('usertype', data.usertype);
            formData.append('company', data.company);
            formData.append('postcode', data.postcode);
            formData.append('solutionUrl', data.solutionUrl);
            formData.append('customerGroup', data.usertype);
            formData.append('productIds', data.productIds);

            axios.post(`${this.config.pimcoreUrl}/${this.locale}/submit-navigator-solution`, formData).then(resolve).catch(reject);
        });
    }
}
